import * as msal from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_MSAL_CLIENT_ID as string,
        authority: process.env.REACT_APP_MSAL_AUTHORITY as string,
        redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI as string,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true,
    },
};

export const msalInstance = new msal.PublicClientApplication(msalConfig);

async function initializeMsal() {
    try {
        await msalInstance.initialize();
    } catch (error) {
        console.error('Error initializing MSAL:', error);
    }
}

export const loginRequest = {
    scopes: process.env.REACT_APP_LOGIN_SCOPES ? process.env.REACT_APP_LOGIN_SCOPES.split(',') : [],
};


initializeMsal();